<template>
  <div class="lecturer_boxs">
    <div class="flexCenter">
      <div :class=" activeIndex == index?'act tabItem':'tabItem'"
           @click="lecturerClick(item,index)"
           v-for="(item,index) in lecturerTypeList"
           :key="index">
        {{item.paramName}}
      </div>
    </div>
    <!-- <div class="lecturer_left">
      <div class="lecturer_left_item"
           :style="{'backgroundColor':activeIndex == index?'#FFC0C2':'','color':activeIndex==index?'#DE1F26':'','fontWeight':activeIndex == index?'700':''}"
           @click="lecturerClick(item,index)"
           v-for="(item,index) in lecturerTypeList"
           :key="index">{{item.paramName}}

        <div v-if="activeIndex == index"
             class="r"></div>
      </div>
    </div> -->
    <div class="lecturer_right">
      <el-empty v-if="alllecturerList.length==0"
                description="暂无讲师"></el-empty>
      <el-carousel indicator-position="outside"
                   :autoplay="false"
                   v-if="alllecturerList.length!=0"
                   style="width:100%"
                   arrow="never"
                   height="100%">
        <el-carousel-item v-for="(x,y) in alllecturerList"
                          :key="y+'x'">
          <div class="flexCenter">
            <div class="lecturer_item"
                 v-for="(item,index) in x"
                 @mouseenter="listmouseover(index)"
                 @mouseleave="listmouseout"
                 @click="toLecturerDetails(item)"
                 :key="index">
              <div class="img">
                <el-image class="dong"
                          :style="{'transform':listIndex==index?'scale(1.5)':''}"
                          :src="item.owPicture"
                          alt=""></el-image>
              </div>
              <div style="height:190px">
                <el-image style="width:100%;height:100%"
                          :src="item.owPictureIntroduce"></el-image>
              </div>
              <div class="mainBgColor tram"
                   :class="listIndex == index ?'mainBgColor tram tran':'mainBgColor tram'"></div>
              <!-- <div class="activeName"
                   v-if="listIndex==index">
                <div> {{item.userName}}</div>
                <div class="content_item">{{item.personalProfile}}</div>
              </div>
              <div v-else
                   class="name">{{item.userName}}</div> -->
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

  </div>
</template>
<script>
import {
  lecturerList, dictTypeList
} from '@/api/api.js'
export default {
  data () {
    return {
      alllecturerList: [],  //讲师列表
      lecturerTypeList: [],  //讲师分类
      list: [
        { url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800', name: '万辉', content: '新零售四大飞轮体系' },
        { url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800', name: '万辉', content: '新零售四大飞轮体系' },
        { url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800', name: '万辉', content: '新零售四大飞轮体系' },
        { url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800', name: '万辉', content: '新零售四大飞轮体系' },
        { url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800', name: '万辉', content: '新零售四大飞轮体系' }
      ],
      activeIndex: 0,
      listIndex: -1,
      data: {
        lecturerType: 1,
        pageNumber: 1, pageSize: 1000
      }
    }
  },
  created () {
    this.getdictTypeList()
    // this.getlecturerList('init')
  },
  methods: {
    split_array (array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength));
      }
      console.log(newArray)
      return newArray;
    },
    async getlecturerList (lecturerType) { //获取讲师列表信息
      if (lecturerType) {
        this.data.lecturerType = lecturerType;
      }
      let data = this.data;
      const res = await lecturerList(data)
      this.alllecturerList = this.split_array(res.data.records, 8)
    },
    async getdictTypeList () {  //获取讲师分类
      const res = await dictTypeList('ow_lecturer_type')
      console.log(res)
      this.lecturerTypeList = res.data;
      this.getlecturerList(this.lecturerTypeList[0].paramValue)
    },
    toLecturerDetails (item) {
      // this.$router.push('/Lecturer?lectureId=' + item.lecturerId + '&lecturerType=' + this.data.lecturerType)
    },
    listmouseover (index) {
      this.listIndex = index;
      console.log(this.listIndex)
    },
    listmouseout () {
      this.listIndex = -1;
    },
    // mouseover (index) {
    //   this.activeIndex = index;
    // },
    lecturerClick (item, index) {
      this.activeIndex = index;
      this.data.lecturerType = item.paramValue;
      this.getlecturerList()
    }
    // mouseout () {
    //   this.activeIndex = 0;
    // },
  }
}
</script>
<style lang="less" scoped>
.lecturer_boxs {
  width: 100%;
  // display: flex;
  // align-items: center;
  .tabItem {
    flex: 1;
    text-align: center;
    height: 60px;
    color: #666666;
    font-size: 20px;
    background-color: #fff;
    margin-bottom: 40px;
    line-height: 60px;
    cursor: pointer;
  }
  .act {
    background-color: #de1f26;
    border-radius: 4px;
    font-weight: bold;
    color: #fff;
  }
  .lecturer_left {
    color: #ffffff;
    font-size: 24px;
    padding: 20px 0;
    margin-right: 50px;
    // box-sizing: border-box;
    background: #de1f26;
    border-radius: 10px;
    .lecturer_left_item {
      padding: 18px 28px;
      font-size: 24px;
      position: relative;
      cursor: pointer;
      .r {
        position: absolute;
        top: 0;
        right: -20px;
        width: 20px;
        height: 100%;
        background-color: #ffc0c2;
      }
    }
  }
  .lecturer_right {
    flex: 1;
    height: 100%;
    .flexCenter {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 100%;
      flex-wrap: wrap;
      .lecturer_item {
        width: calc((100% - 60px) / 4);
        // height: 246px;
        // border-radius: 6px;
        background-color: #ffffff;
        margin-right: 20px;
        padding: 8px;
        box-sizing: border-box;
        margin-bottom: 20px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        .tram {
          width: 0;
          height: 4px;
        }
        .tran {
          animation: fadenum 2s infinite;
          // -moz-animation-play-state: no;
        }
        @keyframes fadenum {
          100% {
            width: 100%;
            // animation-play-state: paused;
          }
        }
        .activeName {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 6px;
          background: rgba(0, 0, 0, 0.6);
          color: #fff;
          padding: 104px 20px 20px 20px;
          box-sizing: border-box;
          .content_item {
            margin: 7px 0 0 0;
            font-size: 12px;
          }
        }
        .name {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 44px;
          color: #fff;
          background: rgba(0, 0, 0, 0.6);
          text-align: center;
          line-height: 44px;
          font-size: 18px;
        }
        .img {
          width: 100%;
          height: 206px;
          overflow: hidden;
          .dong {
            width: 100%;
            height: 100%;
            transition: all 3s;
            z-index: 11;
            overflow: hidden;
          }
          .dong:hover {
            transform: scale(1.5);
          }
        }
      }
      .lecturer_item:nth-child(4) {
        margin-right: 0;
      }
      .lecturer_item:nth-child(8) {
        margin-right: 0;
      }
    }
  }
}
</style>